const server = {
  godseye: {
    baseUrl: `https://godseye.server.sypto.xyz/`,
  },
  ss_dhan: {
    baseUrl: `https://optimus.dhanss.server.sypto.xyz/`,
  },
  ss_dhan_anurag: {
    baseUrl: `https://optimus.dhanss.anurag.server.sypto.xyz/`,
  },

  // server: {
  //   baseUrl: `http://192.168.0.2:8001/`
  // },
};

export default server;

// const server = {
//   host: "localhost:8001",
//   port: "5000",
// };
// server.baseUrl = `http://${server.host}/`;
// export default server;
